import { Component, Inject, ViewChild } from '@angular/core';
import {IATA_SERVICE_TOKEN} from '../shared/services/iata.service';
import {RestrictedIata} from '../shared/models/restricted-iata';
import {DateUtil, NotificationsService, SpinnerComponent as Spinner} from '@westjetairlines/wjesd-component-library';
import {MatPaginator, MatSort, MatTableDataSource} from '@angular/material';
import {SearchableIata} from "../shared/models/searchable-iata";

@Component({
  selector: 'app-manage-iata',
  templateUrl: './manage-iata.component.html',
  styleUrls: ['./manage-iata.component.css']
})
export class ManageIataComponent {
  displayedColumns: string[] = ['iataNumber', 'iataPartner', 'restricted', 'updatedDate'];
  restrictedIatas: Array<RestrictedIata>;
  selectedRestrictedIata : RestrictedIata = new RestrictedIata();
  dataSource: MatTableDataSource<SearchableIata>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  filter: string;

  constructor(@Inject(IATA_SERVICE_TOKEN) private iataService, private notificationService: NotificationsService) {
  }

  ngOnInit() {
    Spinner.start();
    this.iataService.getRestrictedIatas().subscribe(result => {
        if (!result.wasSuccessful) {
          this.notificationService.error(result.brokenRules[0].message);
          this.restrictedIatas = [];
        } else {
          this.restrictedIatas = result.value;
        }
        const searchableIata: SearchableIata[] = [];
        for (let iata of this.restrictedIatas)
          searchableIata.push(this.createFilterableData(iata))

        this.dataSource = new MatTableDataSource(searchableIata);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        if (this.filter)
          this.dataSource.filter = this.filter
      },
      err => {
        console.log('error', err);
        this.notificationService.error(err);
        Spinner.stop();
      },
      () => {
        Spinner.stop();
      });
  }

  applyFilter(filterValue: string) {
    this.filter = filterValue.trim().toLowerCase();
    this.dataSource.filter = this.filter;
  }

  createFilterableData(restrictedIata: RestrictedIata): SearchableIata {
    if (!restrictedIata)
      return {
        iataNumber: '',
        iataPartner: '',
        restricted: '',
        updatedDate: ''
      };
    else
      return {
        iataNumber: restrictedIata.iataNumber ? restrictedIata.iataNumber.toString() : '',
        iataPartner: restrictedIata.iataPartner && restrictedIata.iataPartner.name ? restrictedIata.iataPartner.name.toString() : '',
        restricted: restrictedIata.isIncluded ? 'Yes' : 'No',
        updatedDate: restrictedIata.updatedDate ? DateUtil.getFormattedDate(new Date(restrictedIata.updatedDate)) : DateUtil.getFormattedDate(new Date(restrictedIata.createdDate))
      }
  }

  selectRestrictedIata(selectedIataNumber: string){
    for (let i = 0; i < this.restrictedIatas.length; i++)
    {
      if (this.restrictedIatas[i].iataNumber === selectedIataNumber){
        this.selectedRestrictedIata = this.restrictedIatas[i];
        break;
      }
    }
  }

  addRestrictedIata(){
    this.selectedRestrictedIata = new RestrictedIata();
  }

  refresh(event: any): void {
    this.ngOnInit();
  }
}





// WEBPACK FOOTER //
// ./src/app/manage-iata/manage-iata.component.ts